export default __webpack_public_path__ + "static/media/icon-Motif de la consultation.eefae6b1.svg";